import { Box, Button, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useMemo, useState } from "react";
import { OverflowTypography } from "../../v2/utils/OverflowTypography";
import { Question } from "../../utils/CourseTree";
interface QuizScoreItemProps {
  onClick: () => void;
  text: string;
  score?: { points: number; max_points: number; question?: Question } | null;
  scoreDisplay?: "percentage" | "points";
  groupTargets?: boolean;
  quizStatus?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    position: "relative",
    padding: "16px",
    height: "58px",
    backgroundColor: "#FFF",
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
    "&:active": {
      backgroundColor: "#f2f2f2",
      borderColor: theme.palette.primary.main,
    },
    "&:focus": {
      backgroundColor: "#f2f2f2",
      borderColor: theme.palette.primary.main,
    },
  },
}));

export const QuizScoreItem = (props: QuizScoreItemProps) => {
  const { groupTargets = false, scoreDisplay = "percentage", score } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [hover, setHover] = useState(false);

  const percentage = useMemo(() => {
    const percent = (props.score?.points ?? 0) / (props.score?.max_points ?? 1);
    return Number.isNaN(percent) ? null : percent;
  }, [props.score?.points, props.score?.max_points]);

  return (
    <Button
      disableRipple
      className={classes.root}
      onClick={props.onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        border: groupTargets ? "none" : `2px solid ${theme.palette.neutral.main}`,
        borderRadius: groupTargets ? "0px" : "8px",
      }}>
      <Stack width="100%" direction="row" alignItems="center">
        <Box sx={{ flexGrow: 1, position: "relative", minWidth: "100px" }}>
          <OverflowTypography
            fontSize="16px"
            fontWeight={600}
            variant="h4"
            width="100%"
            height="22.8px"
            alignment="left"
            fadeColor={hover ? "#F2F2F2" : "#FFFFFF"}>
            {props.text}
          </OverflowTypography>
        </Box>
        <Typography
          variant="h4"
          sx={{ marginLeft: "80px", marginRight: "16px" }}
          fontWeight={600}
          fontSize="16px"
          color={theme.palette.text.secondary}>
          {/*the string Bio370 is per ticket MACSUAT-5664*/}
          {props.quizStatus === "No Quiz"
            ? "No Quiz"
            : props.score?.question?.module_id.includes("Bio.370")
            ? "100%"
            : scoreDisplay === "percentage"
            ? percentage === null
              ? "No Quiz"
              : `${Math.round(percentage * 100)}%`
            : score?.max_points === 0
            ? "No Quiz"
            : `${score?.points ?? 0}/${score?.max_points ?? 0}`}
        </Typography>
        {/*the string Bio370 is per ticket MACSUAT-5664*/}
        {props.quizStatus === "No Quiz" ? (
          <Box
            sx={{
              cursor: "pointer",
              color: "#0092E0",
              fontSize: "20px",
              lineHeight: "20px",
            }}>
            <Tooltip placement="bottom" arrow title="No Quiz">
              <i className="fa-solid fa-book"></i>
            </Tooltip>
          </Box>
        ) : props.score?.question?.module_id.includes("Bio.370") ? (
          <Box
            sx={{
              cursor: "pointer",
              color: "#477213",
              fontSize: "20px",
              lineHeight: "20px",
            }}>
            <Tooltip placement="bottom" arrow title="Review">
              <i className="fa-solid fa-trophy"></i>
            </Tooltip>
          </Box>
        ) : score?.max_points === 0 && scoreDisplay === "points" ? (
          <Box
            sx={{
              cursor: "pointer",
              color: "#0092E0",
              fontSize: "20px",
              lineHeight: "20px",
            }}>
            <Tooltip placement="bottom" arrow title="No Quiz">
              <i className="fa-solid fa-book"></i>
            </Tooltip>
          </Box>
        ) : (
          <Box
            sx={{
              cursor: "pointer",
              color: percentage !== null && percentage < 0.8 ? "#F96712" : "#477213",
              fontSize: "20px",
              lineHeight: "20px",
            }}>
            {percentage !== null && percentage < 0.8 ? (
              <Tooltip placement="bottom" arrow title="Try again">
                <i className="fa-solid fa-circle-exclamation"></i>
              </Tooltip>
            ) : (
              <Tooltip placement="bottom" arrow title="Review">
                <i className="fa-solid fa-trophy"></i>
              </Tooltip>
            )}
          </Box>
        )}
      </Stack>
    </Button>
  );
};
